/**
 * @description sigv library 設定資籸
 */
export class Configuration {
  /**
   * @description 執行環境, DEV/SIT/UAT/PROD
   */
  env = 'DEV';

  /**
   * @description 登入頁、無權限頁面與登入後首頁之路由設定
   */
  routePath: {
    /**
     * @description 登入頁路由設定，預設 '/login'
     */
    login: string;
    /**
     * @description 無權限頁路由設定，預設 '/no-permission'
     */
    noPermission: string;
    /**
     * @description 登入後首頁路由設定，預設 '/'
     */
    index: string;
  };

  /**
   * @description System Group Code
   */
  systemGroupCode = '';

  /**
   * @description System Codes
   */
  systemCodes: string[] = [];

  /**
   * @description 是否為進件外網
   */
  isExtranet: boolean;

  /**
   * @description Unknown Error Toast Client-traceid 是否呈現
   */
  isErrorToastTrace: boolean;
  /**
   * @description 是否初始化 Menu
   */
  initMenu?: boolean;

  constructor({
    env,
    routePath = { login: '/login', noPermission: '/no-permission', index: '/' },
    systemGroupCode,
    systemCodes = [],
    isExtranet = false,
    isErrorToastTrace = false,
    initMenu = true,
  }: {
    /**
     * @description 執行環境, DEV/SIT/UAT/PROD
     */
    env: string;
    /**
     * @description 登入頁、無權限頁面與登入後首頁之路由設定
     */
    routePath?: { login: string; noPermission: string; index: string };
    /**
     * @description System Group Code
     */
    systemGroupCode: string;
    /**
     * @description System Codes
     */
    systemCodes: string[];
    /**
     * @description 是否為進件外網
     */
    isExtranet?: boolean;
    /**
     * @description Unknown Error Toast Client-traceid 是否呈現
     */
    isErrorToastTrace?: boolean;
    /**
     * @description 是否初始化 Menu
     */
    initMenu?: boolean;
  }) {
    this.env = env;
    this.routePath = routePath;
    this.systemGroupCode = systemGroupCode;
    this.systemCodes = systemCodes;
    this.isExtranet = isExtranet;
    this.isErrorToastTrace = isErrorToastTrace;
    this.initMenu = initMenu;
  }
}
